import { useRef } from 'react'
import clsx from 'clsx'
import { XIcon } from 'lucide-react'
import $form from '@tandem/ui/form.css'
import $layout from '@tandem/ui/layout.css'
import $ from './FileInput.css'

export interface FileInputProps {
  field: any
  accept?: string
  onValueChange?: (file: File | File[] | null) => void
  label?: string
  multiple?: boolean
}

export default function FileInput({ field, accept, onValueChange, label, multiple }: FileInputProps) {
  let inputRef = useRef<HTMLInputElement>(null)
  let raw = field.state.value
  let files: File[] = multiple
    ? (Array.isArray(raw) ? raw : [])
    : (raw ? [raw as File] : [])

  let displayValue = files.length === 0
    ? label
    : files.length === 1
      ? files[0].name
      : `${files.length} файлов`

  function handleFiles(list: File[]) {
    if (multiple) {
      let next = list
      field.handleChange(next)
      onValueChange?.(next)
    } else {
      let next = list[0] ?? null
      field.handleChange(next)
      onValueChange?.(next)
    }
  }

  function clear() {
    if (multiple) {
      field.handleChange([])
      onValueChange?.([])
    } else {
      field.handleChange(null)
      onValueChange?.(null)
    }
    if (inputRef.current) inputRef.current.value = ''
  }

  return (
    <div class={clsx($.container, $layout.row)}>
      <input
        type='text'
        value={displayValue}
        placeholder=' '
        class={clsx($.input, {
          [$form.error]: !field.state.meta.isValid && field.state.meta.isTouched,
          [$form.empty]: files.length === 0
        })}
        onClick={() => inputRef.current?.click()}
        onKeyDown={(e) => e.preventDefault()}
        style={{ cursor: 'pointer', caretColor: 'transparent' }}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => {
          e.preventDefault()
          let dropped = Array.from(e.dataTransfer.files ?? [])
          if (dropped.length > 0) handleFiles(dropped)
        }}
      />
      {label && (
        <label>
          {label}
        </label>
      )}
      <input
        ref={inputRef}
        type='file'
        accept={accept}
        multiple={multiple}
        style={{ display: 'none' }}
        onChange={(e) => {
          let list = Array.from((e.target as HTMLInputElement).files ?? [])
          if (list.length > 0) handleFiles(list)
        }}
      />
      {files.length > 0 && (
        <button
          type='button'
          class={$.clear}
          onClick={clear}
        >
          <XIcon size={16} />
        </button>
      )}
    </div>
  )
}
